import React from 'react';
import { useState, useEffect } from 'react';
import { withSnackbar } from 'notistack';

import RoleForm from './RoleForm';
import { loadRolesConfig, loadRole, createRole, loadCompany } from './services';

let CloneRole = ({ match, history, enqueueSnackbar, updateBreadcrumbs }) => {
    const { id, company_id: companyId } = match.params;
    const [loading, setLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [roles, setRoles] = useState([]);
    const [role, setRole] = useState(null);
    const removeNames = ({ rules }) => ({
        name: '',
        description: '',
        rules,
    });

    useEffect(() => {
        loadCompany(companyId).then(company =>
            updateBreadcrumbs([
                { name: 'Companies', path: '/companies' },
                {
                    name: company.business_name,
                    path: `/companies/${companyId}`,
                },
                'New Role',
            ])
        );
        let loaded = 0;
        loadRolesConfig().then(config => {
            setRoles(config);
            loaded += 1;
            if (loaded === 2) {
                setLoaded(true);
            }
        });
        loadRole(id, companyId).then(data => {
            setRole(removeNames(data));
            loaded += 1;
            if (loaded === 2) {
                setLoaded(true);
            }
        });
    }, []);

    const handleSave = async data => {
        setLoading(true);
        try {
            await createRole(data, companyId);
            enqueueSnackbar('Partner portal role was added', {
                variant: 'info',
            });
            handleCancel();
        } finally {
            setLoading(false);
        }
    };
    const handleCancel = () =>
        history.push(`/companies/${companyId}/partner/roles`);
    if (!loaded) {
        return null;
    }
    return (
        <RoleForm
            mode="edit"
            loading={loading}
            role={role}
            roles={roles}
            onSave={handleSave}
            onCancel={handleCancel}
        />
    );
};

export default withSnackbar(CloneRole);
